export default __webpack_public_path__ + "static/media/arrow-right-black.a1f7e8f2.svg";